import { useEffect, useState } from "react";
import useApi from "./useApi";

const useStores = ({ page = 1, pageSize = 10 } = {}) => {
  const { request } = useApi();
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("userId"));

  useEffect(() => {
    const syncToken = () => setToken(localStorage.getItem("userId"));
    const handleStorage = (event) => {
      if (!event || event.key === "userId") {
        syncToken();
      }
    };
    window.addEventListener("auth-change", syncToken);
    window.addEventListener("storage", handleStorage);
    return () => {
      window.removeEventListener("auth-change", syncToken);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  useEffect(() => {
    if (!token) {
      setStores([]);
      setSelectedStore(null);
      setIsLoading(false);
      setError(null);
    }
  }, [token]);

  useEffect(() => {
    if (!token) return;
    let isMounted = true;
    const controller = new AbortController();

    const fetchStores = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const data = await request({
          path: "/store/store",
          params: { page, pageSize },
          signal: controller.signal,
        });
        const storeList = Array.isArray(data?.stores) ? data.stores : [];

        if (isMounted) {
          setStores(storeList);
          setSelectedStore((current) => current || storeList[0] || null);
        }
      } catch (err) {
        if (err?.name === "AbortError") return;
        if (isMounted) {
          setStores([]);
          setSelectedStore(null);
          setError(err?.message || "Failed to load stores.");
        }
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    fetchStores();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [page, pageSize, request, token]);

  return {
    stores,
    selectedStore,
    setSelectedStore,
    isLoading,
    error,
  };
};

export default useStores;
